const generateBarChartOptions = (
  questionsData: { intentName: string }[],
  isSmallScreen: boolean
): any => ({
  responsive: true,
  indexAxis: 'y' as const,
  scales: {
    x: {
      beginAtZero: true,
      ticks: {
        display: false
      }
    },
    y: {
      ticks: {
        display: true,
        font: {
          size: 11
        },
        color: '#666'
      }
    }
  },
  maxBarThickness: 14,
  maintainAspectRatio: false,
  clip: false,
  plugins: {
    legend: {
      display: false
    },
    tooltip: {
      callbacks: {
        title: (tooltipItems: any) => {
          const index = tooltipItems[0].dataIndex;
          return questionsData[index].intentName;
        }
      }
    }
  },
  layout: {
    padding: {
      top: 20,
      left: isSmallScreen ? 5 : 8,
      right: isSmallScreen ? 12 : 20,
      bottom: 12
    }
  }
});

export default generateBarChartOptions;
